export default __webpack_public_path__ + "static/media/img-mindmap-banner.f45d8ac5.png";